<template>
  <div class="container std-view">
    <div class="row">
      <div class="col-md-9">
        <div class="flex justify-between items-center mt-1 mb-4">
          <h1 class="my-0">
            ATS List
            <small class="text-sm text-grey-dark">Total: {{ Object.keys(sendToTypesFiltered).length }} of {{Object.keys(sendToTypes).length}}</small>
          </h1>
          <form class="form-inline">
            <input type="text" class="form-control mr-2" v-model="search" placeholder="Search">
            <select class="form-control" v-model="filter">
              <option value="all">All</option>
              <option value="active">Active</option>
              <option value="archived">Archived</option>
            </select>
          </form>
        </div>
      </div>
    </div>
    <div class="row justify-center">
      <!-- Sidebar -->
      <aside class="col-md-3 order-md-2">
        <div class="card" style="position: sticky; top:0;">
          <div class="header-row border-b border-gray-200">Quick Links</div>
          <div class="card-body list-group list-group-flush" style="height:70vh; overflow: scroll; padding:0;">
            <div
              v-for="(details, slug) in sendToTypesFiltered"
              class="list-group-item list-group-item-action">
              <a :href="`#${slug}`">{{details.name}}</a>
            </div>
          </div>
        </div>

      </aside>
      <!-- Main Section -->
      <main class="accordion col-md-9 order-md-1">
        <div v-for="(details, slug) in sendToTypesFiltered">
          <div class="card" :id="slug">
            <div class="header-row border-b border-gray-200">
              {{details.name}}   (id: {{details.id}}, slug: {{slug}})
              <span class="status-indicator" :class="{
                'text-success' : !details.archived,
                'text-danger' : details.archived,
              }" :title="details.archived ? 'Archived' : 'Active'">&bull;</span>
            </div>
            <div class="card-body">
              <h5>Client Provided Info</h5>
              <table v-if="details.rules && Object.keys(details.rules).length" class="table">
                <thead>
                <th>Item</th>
                <th>Description</th>
                <th class="text-center" style="width: 80px;">Required</th>
                <th class="text-center" style="width:100px">Options</th>
                </thead>
                <tbody>
                <tr
                  v-for="(settings, key) in details.rules"
                  :key="key"
                >
                  <td><strong>{{ settings.label }}</strong></td>
                  <td>
                    <span style="white-space: pre-wrap">{{ descriptionWithBreaks(settings.description) }}</span>
                    <div v-if="settings.default_value && !settings.required" v-once>
                      <small><strong>Default:</strong> {{settings.default_value}}</small>
                    </div>
                  </td>
                  <td class="text-center"
                      :class="{
                    'text-danger': isRequired(settings, details.rules, key)
                    }"
                  >
                    {{ isRequired(settings, details.rules, key) ? 'Yes' : 'No' }}
                  </td>
                  <td class="text-center">
                    <select v-if="settings.options"
                            v-model="settings.default_value"
                            style="width:80px;"
                            class="form-control"
                    >
                      <option disabled>Options</option>
                      <option v-for="(optionSettings, option) in settings.options">{{option}}</option>
                    </select>
                    <span v-else>None</span>
                  </td>
                </tr>
                </tbody>
              </table>
              <div class="mb-3" v-if="(!details.rules || !Object.keys(details.rules).length) && !details.rules_description">
                Not Available
              </div>
              <div class="mb-3" v-if="details.rules_description">
                {{details.rules_description}}
              </div>
              <div class="mb-3">
                <h5>Other Info</h5>
                <ul>
                  <li>
                    <strong>Supports Lead Modifications</strong>:
                    {{ details.allow_lead_modifications ? 'Yes' : 'No' }}
                  </li>
                  <li v-if="details.other" v-for="(item, itemKey) in details.other" :key="itemKey">
                    <strong>{{itemKey}}:</strong>
                    {{item}}
                  </li>
                </ul>
              </div>
              <div class="mb-3" v-if="details.resources && Object.keys(details.resources).length">
                <h5>More Resources</h5>
                <ul style="column-count:3;">
                  <li v-for="(link, label) in details.resources">
                    <a :href="link" target="_blank">{{label}}</a>
                  </li>
                </ul>
              </div>
              <div class="mb-3" v-if="details.field_keys && Object.keys(details.field_keys).length">
                <h5>Field Keys</h5>
                <ul style="column-count:3;">
                  <li v-for="(field_key, index) in details.field_keys">
                    {{field_key}}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  </div>
</template>
<script>
  export default{
    data(){
      return {
        closed: [],
        sendToTypes: {},
        filter: 'all',
        search: '',
      }
    },
    props:{
      types: Object,
    },
    computed:{
      sendToTypesFiltered(){
        let sendToTypes = this.sendToTypes
        if(this.filter !== 'all'){
          let filtered = {}
          Object.keys(this.sendToTypes).forEach((slug)=>{
            if(this.filter === 'archived' && this.sendToTypes[slug].archived){
              filtered[slug] = this.sendToTypes[slug]
            }
            if(this.filter === 'active' && !this.sendToTypes[slug].archived){
              filtered[slug] = this.sendToTypes[slug]
            }
          });
          sendToTypes = filtered
        }
        if(this.search !== ''){
          const newSendToTypes = {};
          Object.keys(sendToTypes).forEach((item)=>{
            if(sendToTypes[item].name.toLowerCase().includes(this.search.toLowerCase())){
              newSendToTypes[item] = sendToTypes[item]
            }
          })
          sendToTypes = newSendToTypes
        }
        return sendToTypes
      }
    },
    methods:{
      isRequired(settings, allRules, key){
        if(settings.required) return true
        let logicRequired = false
        for(let rule in allRules){
          if(key === rule) continue
          if(allRules[rule].default_value && allRules[rule].options && allRules[rule].options[allRules[rule].default_value].requires){
            logicRequired = allRules[rule].options[allRules[rule].default_value].requires.includes(key)
          }
        }
        return logicRequired
      },
      descriptionWithBreaks(description){
        if(!description) return ''
        return description.split('\n').map(line=>line.trim()).join('\n\n')
      }
    },
    created(){
      this.sendToTypes = this.types
    }
  }
</script>
<style scoped lang="scss">
  ul{
    list-style: initial;
    margin-left:30px;
  }
  .card-header{
    position:relative;
  }
  .status-indicator{
    font-size:3rem;
    position:absolute;
    cursor:default;
    text-shadow: 0 0 4px;
    top:50%;
    right:10px;
    transform:translateY(-50%);
  }
</style>
